const alwaysTrue = () => true as const;

export default alwaysTrue;
